module.exports = __webpack_public_path__ + "media/images/logos/HELP-University-c6222a87980f44fe3e03a81f1d82eeff.svg";